function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.12.98v15.457l-6.861-7.05-1.246 1.28L9 19.9l8.986-9.232-1.244-1.28-6.862 7.05V.98H8.12z"
});

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMTE5NzggMC45ODA1OTFMOC4xMTk3NyAxNi40MzY5TDEuMjU4OTcgOS4zODc0NEwwLjAxMzQyNzcgMTAuNjY3MUw4Ljk5OTg5IDE5Ljg5OTVMMTcuOTg2NCAxMC42NjcxTDE2Ljc0MjUgOS4zODc0NEw5Ljg4MDAxIDE2LjQzNjlMOS44ODAwMSAwLjk4MDU5MUw4LjExOTc4IDAuOTgwNTkxWiIgLz4KPC9zdmc+Cg==";
export { SvgDownload as ReactComponent };